import React, { useState } from "react";
import Media from "react-responsive";

import Navbar from "../components/general/navbar/Navbar";
import MobileNavbar from "../components/mobile/MobileNavbar";
import PageTitle from "../components/general/PageTitle";
import Footer from "../components/general/Footer";
import MobileFooter from "../components/mobile/MobileFooter";
import MobileProjectTitle from "../components/mobile/MobileProjectTitle";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const Project = ({ images, name, city, state, type }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fadeState, setFadeState] = useState("fade-in");

  const handleImageChange = (direction) => {
    if (images.length <= 1) return; // No transition if only 1 image
    setFadeState("fade-out");
    setTimeout(() => {
      setCurrentImageIndex(
        (prev) => (prev + direction + images.length) % images.length
      );
      setFadeState("fade-in");
    }, 300);
  };

  return (
    <Media query="(max-width: 768px)">
      {(isMobile) => (
        <div className="flex flex-col justify-between items-center font-display text-navy h-screen animate-fadein">
          {isMobile ? <MobileNavbar title={name} /> : <Navbar color="navy" />}
          {isMobile ? (
            <MobileProjectTitle title={name} />
          ) : (
            <PageTitle title={name} />
          )}

          <div className="flex flex-grow items-center justify-center w-full">
            <div className="flex flex-col justify-around w-full max-w-4xl px-4 relative">
              <div className="flex justify-center items-center w-full relative">
                <button
                  className="absolute left-0 top-1/2 transform -translate-y-1/2 p-2 text-lg hover:text-gray-600 z-10 disabled:opacity-30"
                  onClick={() => handleImageChange(-1)}
                  disabled={images.length <= 1}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <Media query="(max-width: 768px)">
                  {(isMobile) => {
                    const src = images[currentImageIndex];
                    const isVideo = typeof src === "string" && /\.webm$/i.test(src);
                    const isGoogleHQ = typeof src === "string" && /prjimg\/googlehq\//i.test(src);

                    const mediaClass = isGoogleHQ
                      ? `absolute inset-0 object-cover object-center w-full h-full transition-opacity duration-300 ease-in-out ${fadeState}`
                      : `absolute inset-0 object-contain w-full h-full px-4 transition-opacity duration-300 ease-in-out ${fadeState}`;

                    if (isMobile) {
                      return (
                        <div className="w-full max-w-sm aspect-video relative overflow-hidden bg-background-color">
                          {isVideo ? (
                            <video
                              className={mediaClass}
                              src={src}
                              controls
                              loop
                              muted
                              playsInline
                              autoPlay
                              aria-label={`Project video ${currentImageIndex + 1}`}
                            />
                          ) : (
                            <img
                              className={mediaClass}
                              src={src}
                              alt={`Project ${currentImageIndex + 1}`}
                            />
                          )}
                        </div>
                      );
                    }

                    return (
                      <div className="w-full max-w-xl aspect-video relative overflow-hidden bg-background-color">
                        {isVideo ? (
                          <video
                            className={mediaClass}
                            src={src}
                            controls
                            loop
                            muted
                            playsInline
                            autoPlay
                            aria-label={`Project video ${currentImageIndex + 1}`}
                          />
                        ) : (
                          <img
                            className={mediaClass}
                            src={src}
                            alt={`Project ${currentImageIndex + 1}`}
                          />
                        )}
                      </div>
                    );
                  }}
                </Media>

                <button
                  className="absolute right-0 top-1/2 transform -translate-y-1/2 p-2 text-lg hover:text-gray-600 z-10 disabled:opacity-30"
                  onClick={() => handleImageChange(1)}
                  disabled={images.length <= 1}
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </div>

              <div className="flex flex-col items-center justify-center w-full p-0">
                <div className="text-center mt-2 text-sm text-navy p-3">
                  {currentImageIndex + 1} / {images.length}
                </div>

                {[
                  ["Location:", `${city}, ${state}`],
                  ["Type:", type],
                ].map(([label, value]) => (
                  <div
                    key={label}
                    className="flex justify-between w-full text-base font-semi mt-1"
                  >
                    <div className="flex-1 font-bold text-right mr-2">{label}</div>
                    <div className="flex-1 text-left">{value}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <br />

          {isMobile ? (
            <MobileFooter />
          ) : (
            <div className="mt-4 w-full">
              <Footer />
            </div>
          )}
        </div>
      )}
    </Media>
  );
};

export default Project;
